document.addEventListener('DOMContentLoaded', function() {
   const accordionItems = document.querySelectorAll('.accordion-item');
   
   const firstItem = accordionItems[0];
   if (firstItem) {
      const firstContent = firstItem.querySelector('.accordion-content');
      const firstContentInner = firstContent.querySelector('div');
      const firstIcon = firstItem.querySelector('.accordion-icon');
   }
   accordionItems.forEach(item => {
      const title = item.querySelector('.accordion-title');
      const content = item.querySelector('.accordion-content');
      const contentInner = content.querySelector('div');
      const icon = item.querySelector('.accordion-icon');
      
      title.addEventListener('click', () => {
      const isOpen = content.style.height !== '0px';
      
      // Close all other accordion items
      accordionItems.forEach(otherItem => {
         if (otherItem !== item) {
            const otherContent = otherItem.querySelector('.accordion-content');
            const otherIcon = otherItem.querySelector('.accordion-icon');
            otherContent.style.height = '0px';
            otherIcon.style.transform = 'rotate(0deg)';
            otherItem.classList.remove('active');
         }
      });

      // Toggle current accordion item
      if (isOpen) {
         content.style.height = '0px';
         icon.style.transform = 'rotate(0deg)';
         item.classList.remove('active');
      } else {
         content.style.height = contentInner.offsetHeight + 'px';
         icon.style.transform = 'rotate(45deg)';
         item.classList.add('active');
      }
      });
   });
});
